module.exports = __webpack_public_path__ + "media/images/front/J&J-93ee40829c7dfaccd1009e42a94858c5.png";